import React, { useCallback, } from 'react';
import { connect, } from 'react-redux';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { ShopCartItem, } from 'store/ducks/shopCart/types';
import { shopCartOperations, } from 'store/ducks/shopCart';
import { formatPrice, } from 'common/functions';
import { layout, } from 'styles';

type Props = {
    items: Array<ShopCartItem>,
    removeItemFromShopCart: Function,
};

const ShoppingCartList: React.FC<Props> = ({ items, removeItemFromShopCart, }) => {
    const itemTextClasses = layout.makeCartShopItemTextStyles();
    const removeItemButtonClasses = layout.makeCartShopButtonRemoveItemStyles();

    const removeItemFromShopCartHandler = useCallback(
        (id, quantity) => () => removeItemFromShopCart(id, quantity),
        [ removeItemFromShopCart, ]
    );

    const renderItems = useCallback((item: ShopCartItem) => {
        const primary = (
            <Box flexBasis="55%">
                {item.details.name}
            </Box>
        );

        const secondary = (
            <Box flexBasis="33%"
                 display="flex"
                 flexGrow={2}
                 justifyContent="flex-end"
                 alignItems="flex-end">
                {/* TODO PB Handle a set product case. */}
                {item.details.price && <span>{item.quantity} x {formatPrice(item.details.price)}</span>}
                <Button color="secondary"
                        size="small"
                        classes={removeItemButtonClasses}
                        onClick={removeItemFromShopCartHandler(item.details.id, item.quantity)}>
                    usuń
                </Button>
            </Box>
        );

        return (
            <ListItem key={item.code}
                      alignItems="flex-start"
                      divider>
                <ListItemText disableTypography
                              classes={itemTextClasses}
                              primary={primary}
                              secondary={secondary} />
            </ListItem>
        );
    }, [ itemTextClasses, removeItemButtonClasses, removeItemFromShopCartHandler, ]);

    return (
        <Box maxHeight={150}
             overflow="auto">
            <List>
                {items.map(renderItems)}
            </List>
        </Box>
    );
};

const mapDispatchToProps = {
    removeItemFromShopCart: shopCartOperations.removeItemFromShopCart,
};

export default connect(
    null,
    mapDispatchToProps,
)(ShoppingCartList);
